module.exports = __webpack_public_path__ + "static/client21-fc3516970d960b87f55eea3320dbaf48.png";